import { useState } from "react";
import {
  Avatar,
  DisplayOn,
  GridIcon,
  IconButton,
  Tooltip,
  onEnterKey,
} from "@songtradr-one/components-frontend";
import { NotificationsPanel } from "@songtradr-one/notifications-frontend";
import { SubModule } from "@songtradr-one/shared-common";
import { Flex, useAppContext } from "@songtradr-one/shared-frontend";
import {
  NavBar,
  NavBarLinks,
  NavBarTools,
  text,
  useAppHeader,
} from "./AppHeader.Parts";
import { Branding } from "./branding/Branding";
import { ControlCenterDropdown } from "./control-center-dropdown/ControlCenterDropdown";
import { CustomerSupport } from "./customer-support/CustomerSupport";
import { NavBarLink } from "./nav-bar-link/NavBarLink";
import { UserMenu } from "./user-menu/UserMenu";

export const AppHeader = () => {
  const { user } = useAppContext();
  const {
    userMenuOpen,
    controlCenterOpen,
    isHome,
    subModules,
    setShowUserMenu,
    setControlCenterOpen,
    toggleControlCenter,
    toggleUserMenu,
    navigate,
    location,
  } = useAppHeader();

  const [controlCenterAnchor, setControlCenterAnchor] =
    useState<HTMLElement | null>(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState<HTMLElement | null>(
    null,
  );

  return (
    <>
      <CustomerSupport onOpenChange={() => navigate(location.pathname)} />
      <UserMenu
        anchor={userMenuAnchor}
        open={userMenuOpen}
        onOpenChange={setShowUserMenu}
        subModules={subModules}
      />
      {controlCenterOpen && (
        <ControlCenterDropdown
          anchor={controlCenterAnchor}
          onOpenChange={setControlCenterOpen}
          open={controlCenterOpen}
        />
      )}
      <NavBar
        ref={(node) => {
          setControlCenterAnchor(node);
        }}
        $dropdownOpen={controlCenterOpen}
      >
        <NavBarLinks>
          <DisplayOn large xlarge>
            {subModules.map((subModule: SubModule, index: number) => (
              <NavBarLink
                key={index}
                text={subModule.label}
                route={subModule.route}
                type={subModule.type}
                active={location.pathname.includes(subModule.route)}
                onClick={() => setControlCenterOpen(false)}
              />
            ))}
          </DisplayOn>
        </NavBarLinks>
        <Branding />
        <NavBarTools>
          <Flex $align="center" $gap="0rem" $wrap="nowrap">
            <NotificationsPanel />
            {!isHome && (
              <Tooltip tip={text.controlCenter.title}>
                <IconButton
                  $active={controlCenterOpen}
                  onClick={toggleControlCenter}
                  aria-expanded={controlCenterOpen}
                >
                  <GridIcon />
                </IconButton>
              </Tooltip>
            )}
          </Flex>
          <Avatar
            user={user}
            img={user?.picture ?? undefined}
            open={userMenuOpen}
            ref={user ? setUserMenuAnchor : undefined}
            onClick={toggleUserMenu}
            onKeyDown={onEnterKey(toggleUserMenu)}
          />
        </NavBarTools>
      </NavBar>
    </>
  );
};
